class Links {
	constructor() {
		this.pageLinksAnchors();
	}

	pageLinksAnchors() {
		const links = document.querySelectorAll('a[href^="#"]');
		const navHeight = 100;
		const navFixHeight = 70;
		const gap = 30;
		const breakPoint = 200;

		links.forEach(link => {
			link.addEventListener('click', function (e) {
				e.preventDefault();

				let targetElement = document.querySelector(this.getAttribute('href'));
				let scrollTop = window.scrollY;

				let targetElementTop;
				if (scrollTop <= breakPoint) {
					targetElementTop = targetElement.getBoundingClientRect().top + scrollTop;
				} else {
					targetElementTop = targetElement.getBoundingClientRect().top + scrollTop;
					// targetElementTop = targetElement.getBoundingClientRect().top + scrollTop + navHeight;
				}

				let topGap;
				if (targetElementTop <= breakPoint) {
					topGap = gap;
					// topGap = gap + navHeight;
				} else {
					topGap = gap + navFixHeight;
				}
				let topPosition = targetElementTop - topGap;

				window.scrollTo({
					top: topPosition,
					left: 0,
					behavior: "smooth",
				});
			})
		})
	}
}

new Links();
